<template>
  <div>
    <b-modal
      id="modal-add-item"
      dialog-class="modalAddItem"
      body-class="bodyModalItem"
      hide-header
      hide-footer
    >
      <div class="closeDIV">
        <b-icon-x />
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 pl-0 pr-0">
            <div class="row">
              <div class="col-12 col-md-2 col-xl-1 pl-0 pr-0">
                <div class="categorias">
                  <div class="opc selected">
                    <img
                      src="@/assets/img/icons8_cocktail_96px.png"
                      width="40"
                    />
                    Drinks
                  </div>
                  <div class="opc">
                    <img
                      src="@/assets/img/icons8_soda_can_96px.png"
                      width="40"
                    />
                    Bebidas
                  </div>
                  <div class="opc">
                    <img
                      src="@/assets/img/icons8_hamburger_96px.png"
                      width="40"
                    />

                    Lanches
                  </div>
                  <div class="opc">
                    <img src="@/assets/img/icons8_pizza_96px.png" width="40" />

                    Pizzas
                  </div>
                  <div class="opc">
                    <img
                      src="@/assets/img/icons8_sashimi_96px.png"
                      width="40"
                    />

                    Sushi
                  </div>
                  <div class="opc">
                    <img src="@/assets/img/icons8_nachos_96px.png" width="40" />

                    Porções
                  </div>
                  <div class="opc">
                    <img
                      src="@/assets/img/icons8_noodles_96px.png"
                      width="40"
                    />
                    Massas
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-10 col-xl-11">
                <div class="row">
                  <div class="col-12 col-md-4">
                    <b-input placeholder="Pesquisar..." />
                  </div>
                </div>
                <div
                  v-if="itemSelecionado && itemSelecionado.ingredientes && itemSelecionado.ingredientes.length > 0"
                  class="mt-3"
                >
                  <h5>Adicionais disponíveis</h5>
                  <div
                    v-for="(ing, idx) in itemSelecionado.ingredientes"
                    :key="'ing_' + idx"
                    class="form-check"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :id="'adicional_' + idx"
                      v-model="adicionaisSelecionados"
                      :value="ing"
                    />
                    <label
                      class="form-check-label"
                      :for="'adicional_' + idx"
                    >
                      {{ ing.ingrediente }} (+R$ {{ $options.filters.currency(ing.valor) }})
                    </label>
                  </div>
                </div>
                <div v-if="itemSelecionado">
                  <div class="mt-2">
                    <b>Valor do item: </b> R$ {{ $options.filters.currency(valorTotalItem) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 bg-light d-flex justify-content-between mt-2 pt-3"
            style="border-top:1px solid #ccc"
          >
            <button type="button" class="btn btn-secondary btn-def">
              <i class="fa-solid fa-angle-left mr-2" style="font-size:20px" />
              Voltar
            </button>
            <button
              type="button"
              class="btn btn-success btn-def"
              @click="adicionarItem"
            >
              <b-icon-check /> Adicionar Item
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      itemSelecionado: null, // O item atualmente selecionado
      adicionaisSelecionados: [], // Lista de adicionais selecionados
    };
  },
  computed: {
    valorTotalItem() {
      if (!this.itemSelecionado) return 0;
      let base = this.itemSelecionado.preco_venda || 0;
      if (this.adicionaisSelecionados && this.adicionaisSelecionados.length > 0) {
        base += this.adicionaisSelecionados.reduce((acc, ing) => acc + (ing.valor || 0), 0);
      }
      return base;
    },
  },
  methods: {
    adicionarItem() {
      // Emitir evento para o componente pai adicionar o item com adicionais
      this.$emit('add-item', {
        ...this.itemSelecionado,
        adicionais: this.adicionaisSelecionados,
        valorTotal: this.valorTotalItem,
      });
      this.adicionaisSelecionados = [];
      this.itemSelecionado = null;
      this.$bvModal.hide('modal-add-item');
    },
    // ...existing code...
  },
  filters: {
    currency(value) {
      if (typeof value !== 'number') return value;
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>

<style lang="scss" >
.bodyModalItem {
  @media screen and (max-width: 575px) {
    padding: 0px !important;
    padding-bottom: 5px !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
}
.closeDIV {
  font-size: 40px !important;
  color: gray;
  position: absolute;
  right: 10px;
  top: 0px;
  @media screen and (max-width: 575px) {
    display: none;
  }
}
.categorias {
  margin: 0 auto;
  .opc {
  }

  @media screen and (max-width: 575px) {
    width: 100%;
    height: 86px;
    display: flex;
    flex-flow: row ;
    overflow: auto;
    margin-bottom: 15px;
    align-items: center;

    &::-webkit-scrollbar {
      height: 1px;
      
      
    }
    &::-webkit-scrollbar-thumb{
      background: #999 !important;
    }

    .opc {
      min-width: 80px !important;
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      border-radius: 15px;
      height: 75px;
      font-size:12px;
      img{
          width:35px;
          margin-bottom: 5px;
      }
    }
  }
  @media screen and (min-width: 575px) {
    min-height: 400px;
    // border-right: 1px solid #dedede;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    .opc {
      width: 80%;
      max-height: 80px;
      font-size: 15px;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      justify-content: center;
      padding: 10px;
      margin-bottom: 5px;
      border-radius: 15px;
      cursor: pointer;

      &:hover {
        background: #cccccc50;
      }
    }
  }

  .selected {
    background: #cccccc50;
  }
}

.modalAddItem {
  width: 95% !important;
  max-width: 100% !important;
  border-radius: 15px !important;

  .modal-content {
    border-radius: 15px !important;
  }

  @media only screen and (max-width: 575px) {
    width: 100% !important;
    margin: 0px !important;
    padding: 0px !important;
    border-radius: 0px !important;
    .modal-content {
      border-radius: 0px !important;
    }
  }
}

.btn-def {
  height: 50px;
  min-width: 120px;
  text-align: center;
  display: flex !important;
  align-items: center !important;
  justify-content: center;
  svg {
    font-weight: bolder;
    font-size: 35px !important;
  }
}
</style>